<template>
  <div>
    <unicom-linha :espacamento="false" style="min-height: 35px">
      <unicom-coluna sm="auto" alinhamento="center" class="mr-3">
        <unicom-icone style="color: #dee2e6" nome="pie-chart" :tamanho="25" />
      </unicom-coluna>
      <unicom-coluna sm="auto" alinhamento="center">
        <div
          style="color: #dee2e6; font-size: 21px"
          class="negrito fonte-primaria"
        >
          Prestadores por região
        </div>
      </unicom-coluna>
    </unicom-linha>
    <content-loader
      style="height: auto; position: absolute; max-height: 450px"
      :width="480"
      :height="480"
      primaryColor="#DEE2E6"
      secondaryColor="#f6f6f6"
      viewBox="0 0 480 480"
      :speed="1"
    >
      <path
        d="M9.948,159.572c-0.2,2.6,1,4.5,2.4,6.5c1,1.5,2.2,3.2,2.4,4.9c0.3,2.8,1.8,3.5,4.1,4c2.6,0.6,4.7,2,5.4,4.8
            c0.7,2.6,2.1,3.3,4.7,2.3c5.1-1.9,10.2-4,15.3-6c-0.1,0.6-0.3,1.5-0.4,2.4c-0.4,3.6-1,7.2-0.9,10.7c0.1,3.7,2.4,6,5.8,6
            c6.6,0,13.1-0.1,19.7-0.3c3.2-0.1,6-1.3,8.2-3.8c0.3-0.3,0.7-0.8,1-0.7c3.9,0.7,6-2,8.4-4.3c2.7-2.6,5.8-4.4,9.8-4.3
            c2.5,0.1,5.1-0.7,8-1.1c0,0,0.4,0.5,0.7,1.1c1.4,2.2,2,4.2,0.3,6.7c-0.8,1.3-0.4,3.4-0.5,5.2c-0.1,1.3,0.2,2.8-0.2,4
            c-0.6,1.9-0.7,3.6,0.1,5.5c2.2,4.8,5.6,8.6,9.6,11.9c2.2,1.8,4.6,2.4,7.4,1.9c0.9-0.1,2,0.4,2.9,0.9c1.2,0.7,2.1,2.1,3.3,2.4
            c1.8,0.5,3,1.3,4.1,2.6c1.5,1.8,3.4,3,5.8,2.6c1.8-0.3,2.6,0.2,3.1,2c1.1,3.8,3.4,4.9,7.3,4c1.1-0.3,2.6,0,3.7,0.5
            c2.5,1.1,4.8,2.6,7.2,3.7c1.6,0.7,2.4,1.7,2.6,3.3c0.3,2.3,0.5,4.5,0.5,6.8c-0.1,3.1,0.3,6.3-2.4,8.8c-0.4,0.3-0.6,1.101-0.6,1.601
            c0.3,2.6,0.8,5.1,2.9,6.899c3.5,3,7.6,4.8,12.2,5.2c2,0.2,4.1,0,6.2,0.1c2.7,0.101,3.6,1.4,2.9,3.9c-0.2,0.6-0.4,1.3-0.7,1.9
            c-2.6,5.3-1,8.8,4.5,10.5c1.1,0.399,2.7,1.6,2.7,2.399c0.2,4.2,2,8.7-1.3,12.601c-0.4,0.399-0.8,0.899-0.9,1.5
            c-0.2,1.1-0.6,2.5-0.2,3.399c0.5,1.101,0.5,1.7-0.2,2.601c-1.5,2-2.5,4-2.7,6.6c-0.3,5.3-1,10.6-1.4,15.9
            c-0.2,2.6-0.3,5.3-0.2,7.899c0.1,2.2,1.3,4.101,3.5,4.601c3,0.6,6.1,1,9.1,1c8.1,0,14.1,7.199,12.7,15.199
            c-0.4,2.101-0.3,4.4-0.2,6.601c0.1,2.8,1,3.399,3.8,2.899c1.3-0.199,2.6-0.6,3.9-0.699c3.2-0.2,5.5,1.8,5.1,5
            c-0.4,3.6-1.1,7.3-2.3,10.699c-1.3,3.801-1.6,3.7,1.7,6.001c3.3,2.3,4.6,5.5,4.1,9.399c-0.3,2.601-1,5.101-1.1,7.7
            c-0.1,4-2.8,6.1-5.8,7.1c-8.1,2.5-14.3,7.601-20.3,13.101c-3.7,3.399-6.9,7.2-10.3,10.899c-1.9,2-2,3.301-0.5,5.7
            c0.4,0.7,0.8,1.4,1.3,2c2.4,3.101,5.5,5.7,4.5,10.4c-0.4,1.899,1,2.8,2.9,2.2c0.8-0.2,1.5-0.601,2.2-1.101c1.6-1.1,2.9-0.5,3.9,0.7
            c3.9,4.9,8.3,9.1,13.2,12.8c2.2,1.601,3.9,3.7,4.3,6.4c0.3,2.3,1.7,2.5,3.5,2.3c1.7-0.2,3.3-0.7,5.1-1.1c1.1,2.3,2.8,2.6,4.4,0.6
            c0.7-0.9,1.5-1.9,1.7-3c1.1-4.5,3.2-8.2,6.6-11.4c3.299-3.1,6.2-6.6,9.4-10.1c0.2,0.2,0.6,0.4,0.899,0.7
            c2.5,2.6,5.4,2.399,7.301-0.601c1.1-1.8,2.199-3.6,3.1-5.6c1.6-3.4,3.9-5.9,6.9-8.1c2.1-1.601,3.899-3.601,5.399-5.7
            c2.4-3.5,3.2-7.8,3.7-11.9c0.5-3.6,0.7-7.3,1.1-10.899c0.101-1.4,0.4-2.801,0.601-4.101c0.7-4.5,4.5-8,3.899-13
            c1,0.5,1.7,1,2.5,1.4c1.4,0.6,2.5,0.399,3.2-1.2c1.5-3.6,4.7-5.3,8.101-6.3c2.7-0.9,5-2.101,7.2-3.9c2.5-2.1,5.1-4.1,8.8-3.9
            c5.399,0.2,10.399-1.1,14.2-5.3c3.3-3.6,6.8-4.2,11-1.8c2.699,1.5,5.699,1.7,8.8,1.3c6-0.899,11.2-3.5,16.1-6.899
            c3.8-2.7,7.2-5.801,9.2-10.2c1.3-2.9,3.3-5.2,6.4-6.4c1-0.399,2-0.8,2.699-1.5c3.9-4.7,7.801-9.5,11.601-14.399
            c1.899-2.5,1-5.5,1.2-8.301c0.1-2.6,0.399-5.399,2.699-6.899c4-2.7,6-6.601,7.601-10.8c0.7-1.7,0.7-3.7,1-5.5
            c-0.101-0.301,0.6-0.5,0.7-0.801c0.399-1.199,0.699-2.5,0.899-3.8c0.7-3.6,1.4-7.1,2-10.7c0.7-4.3,1.3-8.6,1.9-12.899
            c0.6-4,0.8-8,1.6-12c0.5-2.8,2.101-5.3,5-6.2c9.4-3.2,15.9-9.3,18.7-18.8c1.4-4.6,4.1-6.8,8.6-7.6c5.101-0.9,9.801-2.7,12.801-7.3
            c0.8-1.3,1.3-2.8,2.3-3.9c2.6-2.8,5.399-5.4,8.1-8.1c6.4-6.3,8.8-13.7,6.601-22.5c-0.801-3-1.2-6-1.7-9.1c-0.4-2.5-0.2-5.2-0.9-7.6
            c-1.6-5.3-4.6-9.5-10.7-10.5c-1.699-0.3-3.3-0.8-5-1c-3.699-0.6-6.8-2.2-9.1-5c-4-5.1-7.9-10.4-11.6-15.7
            c-2.4-3.4-4.2-7.1-9.101-7.5c-0.6,0-1.3-0.9-1.7-1.6c-2-3.5-5-5.3-8.899-5.7c-2.101-0.2-4.4-0.4-6.3,0.2
            c-5.5,1.8-10.5,0.2-15.4-1.7c-2-0.7-4-2-5.4-3.5c-1.8-1.9-4-2.8-6.399-3.1c-4.601-0.7-8.9,0.6-13.101,2.2
            c-2.1,0.8-4.3,1.6-6.699,2.4c1.1-4.3,2.1-8.2,3.199-12.1c0.5-1.9,0.301-2.9-1.699-3.7c-3-1.3-5.801-3-8.601-4.7
            c-1.399-0.9-2.5-2.2-4-3.1c-5.3-3.2-11.1-5-17.2-6.2c-6.8-1.3-13.199-0.3-18.8,4.1c-2.8,2.2-5.6,4.3-8.3,6.3
            c-0.9-2.1-2.2-3.9-3.8-5.3c1-0.1,2.1-0.4,3.1-0.8c2-0.8,4-1.7,5.7-2.9c3-2.3,6-4.7,8.7-7.4c1.6-1.6,1.2-2.9-0.9-3.9
            c-5.8-2.8-12-3.9-18.399-3.9c-3,0-5.501,1.2-7.801,2.6c-2.399,1.5-4.5,3.3-7,4.7c-2,1.1-4.1,2.2-7.1,1.5
            c0.899-1.9,1.399-3.8,2.5-5.3c4.5-6.2,10.1-11.1,16.8-14.8c1.9-1,3.5-2.3,3.101-4.8c-0.3-1.8,0.399-3,1.8-4
            c1.1-0.8,2.1-1.7,3.5-2.9c-1.3-0.7-2.101-1.3-3.101-1.6c-1.899-0.7-4.1-1-5.899-1.9c-1.2-0.6-2.4-1.8-2.7-3
            c-0.601-2.3-0.4-4.8-1-7.2c-1.2-5.5-2.7-11-4-16c-2.5-1.7-4.101-0.7-5.5,0.9c-1.4,1.5-3,2.8-4.3,4.4c-0.601,0.8-1.101,2-0.9,3
            c0.4,3,0.4,3.5-2.4,4.2c-2.5,0.7-4,2.2-4.8,4.4c-0.6,1.6-1.8,2.4-3.399,2.8c-4.5,1.1-8.9,0.8-13.4,0.2c-3.399-0.5-6.5-1.3-8.5-4.4
            c-0.399-0.7-1.399-1.2-2.1-1.3c-2.9-0.5-5.8-0.8-8.7-1.3c-2.1-0.4-3.3,0.3-4.5,2.1c-2.1,3.4-7.1,7.2-12.6,5
            c-3.5-1.4-7.2-0.9-10.8,0.3c-3.4,1.1-6.9,1.9-10.4,2.5c-2.5,0.5-5,0.1-7-1.8c-4.3-4-6.8-9-7.5-14.9c-0.6-4.9,1.3-9.1,3.8-13
            c2.7-4.1,2.6-4.6-1.1-7.5c-1.8-1.4-2.5-3-2-5.2c0.2-0.9,0.8-1.8,0.6-2.5c-0.2-1.1-0.7-2.5-1.5-2.9c-2.3-1.2-4.1-0.5-5.9,2
            c-2.5,3.3-4.7,7-9.2,7.7c-3.2,0.5-6.5,0.8-9.8,1.1c-0.8,0.1-1.6-0.2-2.4-0.1c-2.5,0.1-3.8,1.8-5,3.7c-2.1,3.5-3,3.6-6,0.8
            c-0.3-0.2-0.5-0.6-0.8-0.7c-2.7-1.4-5.3-2.8-8-3.9c-0.7-0.3-2.2,0.4-2.7,1.1c-1.8,2.5-1.8,5.4-1.1,8.3c1,3.8,2.8,6.7,6.7,8.5
            c3.4,1.6,3.2,5.7,0,7.5c-1,0.6-2.2,0.9-3.2,1.5c-6.8,3.9-13.6,7.8-20.4,11.8c-1.4,0.9-2.7,0.9-4.1,0.3c-2.6-1.2-5.1-1.3-7.5,0.5
            c-0.3,0.3-1.2,0.3-1.6,0c-3.1-2.1-5.6-4.6-6.3-8.6c-0.6-3.5-2.3-6.1-6.1-7c-2.6-0.6-4.9,0-7.3,0.8c-3.4,1.1-6.7,1.2-10.3,0.7
            c-2.5-0.4-5.1-0.3-7.6,0c-1.7,0.2-2.8,1.6-3,3.4c-0.2,1.9,1,3,2.6,3.7c1.1,0.5,2.3,0.8,3.1,1.6c0.8,0.7,1.5,1.9,1.5,2.8
            c0,0.7-1.1,1.7-1.9,2c-1.2,0.4-2.6,0.5-3.9,0.5c-4.7,0.2-6.9,3.1-5,7.4c1.2,2.7,2.9,5.3,4.8,7.6c3.5,4.5,3.9,8.7,0.7,13.3
            c-1.8,2.6-3.5,5.3-2.5,8.8c0.2,0.7-0.1,1.6-0.5,2.3c-1.4,3-2.4,6.1-2.3,9.6c0,0.8-0.3,1.7-0.6,2.5c-0.5,1.8-1.4,3.6-1.5,5.4
            c-0.3,4.4-2.2,6-6.3,4.7c-3.9-1.3-7.3-0.7-10.8,1.2c-1.2,0.6-2.7,0.7-4.1,0.8c-1.6,0-3.2-0.3-4.9-0.5c-0.4,2.2-1.9,3.1-3.9,3.4
            c-0.5,0.1-0.9,0.4-1.3,0.7c-6.4,4.4-8.7,11.2-10.4,18.3c-0.5,1.9-0.6,3.7-2.9,4.8c-1.5,0.7-2.8,2.3-3.8,3.8
            c-2.5,3.7-2.4,6.4,0.4,9.9C9.148,155.472,10.148,157.271,9.948,159.572z"
      />
    </content-loader>
  </div>
</template>

<script>
import { ContentLoader } from "vue-content-loader";

export default {
  components: {
    ContentLoader
  }
};
</script>

<style></style>
